import React, {useState} from "react";
import {useCurrentData} from "state/queries";
import MUIDataTable from "mui-datatables";
import ErrorLoading from "cis-common-ts/dist/components/error-loading";
import useClasses from "./index.style";
import CircleIcon from "@material-ui/icons/FiberManualRecord";
import czech from "cis-common-ts/dist/mui-datatables/translations/czech";
import { format } from "date-fns";
import {Box} from "@material-ui/core";

const TableScene: React.FC = () => {
    const {
        data: currentData,
        isLoading,
        isError,
        refetch,
    } = useCurrentData({
        onSuccess: () => setLastUpdateTime(new Date()),
        refetchInterval: 1000
    });

    const classes = useClasses();

    const [ lastUpdateTime, setLastUpdateTime ] = useState(new Date());

    const formatTime = (date: Date) => format(date, "HH:mm:ss");

    return (
        <Box className={classes.root}>
            <ErrorLoading
                isLoading={isLoading}
                isError={isError}
                errorMessage={"Nepodařilo se stáhnout data z meteostanic"}
                reload={refetch}
            >
                <MUIDataTable
                    title={`Data meteostanic (poslední aktualizace: ${formatTime(lastUpdateTime)})`}
                    data={currentData ?? []}
                    columns={[
                        { name: "stationName", label: "Stanice"},
                        { name: "online", label: "Stav", options: {
                            customBodyRender: (value) => (
                                <CircleIcon
                                    className={value
                                        ? classes.online
                                        : classes.offline
                                    }
                                />
                            ),
                        }},
                        { name: "temperature", label: "Teplota", options: {
                            customBodyRender: (value) => `${value} °C`
                        }},
                        { name: "humidity", label: "Relativní vlhkost vzduchu", options: {
                            customBodyRender: (value) => `${value} %`
                        }},
                        { name: "windSpeed", label: "Rychlost větru", options: {
                            customBodyRender: (value) => `${value} m/s`
                        }},
                        { name: "twilight", label: "Soumrak", options: {
                            customBodyRender: (value) => Number.parseInt(value) < 0
                                ? "-"
                                : `${value} Lux`
                        }},
                        { name: "precipitation", label: "Déšť", options: {
                            customBodyRender: (value) => value ? "Prší" : "Neprší"
                        }},
                        { name: "brightnestEast", label: "Jas východ", options: {
                            customBodyRender: (value) => `${value} kLux`
                        }},
                        { name: "brightnestSouth", label: "Jas jih", options: {
                            customBodyRender: (value) => `${value} kLux`
                        }},
                        { name: "brightnestWest", label: "Jas západ", options: {
                            customBodyRender: (value) => `${value} kLux`
                        }},

                    ]}
                    options={{
                        download:false,
                        print: false,
                        pagination: false,
                        filter: false,
                        selectableRows: "none",
                        textLabels: czech,
                        elevation: 0
                    }}
                />
            </ErrorLoading>
        </Box>
    )
}

export default TableScene;
